/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.marcas': 'Marcas',
'marcas.agregarMarcas': 'Create Marcas',
'marcas.modificarMarcas': 'Edit Marcas',
'marcas.eliminarMarcas': 'Delete Marcas',
'marcas.marcaId': 'Marca   Id ',
'marcas.empresaId': ' Empresa   Id ',
'marcas.marcaDescripcion': ' Marca   Descripcion',
'marcas.marcas': 'Marcas',
'marcas.verMarcas': 'View Marcas',
};

